
import React, { useRef, useState, useEffect, useCallback } from "react";
import Slider from "react-slick";

import {
  Grid,
  Card,
  CardMedia,
  Typography,
  Button,
  Box,
  Divider,
  IconButton,
  CircularProgress,
  Container,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions, Skeleton,
  Checkbox
} from "@mui/material";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import PauseIcon from "@mui/icons-material/Pause";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { useNavigate, useParams } from "react-router-dom";
import { get_rental_details, rental_enquiry, get_kyc_list, kyc_verification, get_settings } from "../../api/ControllApi";
import BreadcrumbsNav from "../../components/common/BreadCrumbNav";
import RentalLocation from "./RentalLocation";
import theme from "../../utils/theme";
import ShareIcon from "@mui/icons-material/Share";
import RentalDescription from "./RentalDescription";
import { toast } from "react-toastify";
import CallIcon from "@mui/icons-material/Call";
import { useModal } from "../../context/ModalContext";
import { Link } from "react-router-dom";
import RentalDocument from "./RentalDocument";
import { rental_document_pay } from "../../api/Payment";
import { get_page } from "../../api/PageApi";

import CloseIcon from '@mui/icons-material/Close';
import YouTubeIcon from "@mui/icons-material/YouTube";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import PlotDocumentSection from "../Plot_marketPlace/document_section";
import { useCachedApi } from "../../hooks/useCachedApi";
import ResdentialImageView from "../Residential_Properties/ResidentialImageView";
// residential_enquiry
export default function RentalYieldDetail() {
  const { requestApi } = useCachedApi();
  const { id } = useParams();
  const navigate = useNavigate();
  const sliderRef = useRef();
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(false);
  const [paymentLoading, setpaymentLoading] = useState(false);

  const [enquiredloading, setEnquiredLoading] = useState(false);
  const [enquired, setEnquired] = useState(false);
  const { requireLogin } = useModal();
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [documents, setDocument] = useState([])
  const [mapLoading, setMapLoading] = useState(true);
  const [acceptTerms, setAcceptTerms] = useState(false);
  const [bookingTerms, setBookingTerms] = useState("");
  const [downloadTerms, setDownloadTerms] = useState("");
  const [documentTerms, setDocumentTerms] = useState("");
  const [loadingBooking, setLoadingBooking] = useState(false);
  const [loadingDownload, setLoadingDownload] = useState(false);
  const [loadingDocument, setLoadingDocument] = useState(false);
  const [isPlayingMap, setIsPlayingMap] = useState({});
  const [hoveredVideo, setHoveredVideo] = useState(null);
  const videoRefs = useRef({});
  const previewVideoRefs = useRef({});
  const [showKycSection, setShowKycSection] = useState(false);
  const [showPaymentSummary, setShowPaymentSummary] = useState(false);
  const [kycList, setKycList] = useState([]);
  const [selectedKycIds, setSelectedKycIds] = useState([]);
  const [kycLoading, setKycLoading] = useState(false);
  const [settings, setSettings] = useState(null);


  // Slider settings
  const sliderSettings = {
    dots: true,
    infinite: false, // Disable infinite to fix video ref/cloning issues
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };
  const handleShare = () => {
    const shareUrl = window.location.href;

    if (navigator.share) {
      navigator.share({
        title: data?.property_name || "Property",
        text: "Check out this property",
        url: shareUrl,
      });
    } else {
      navigator.clipboard.writeText(shareUrl);
      alert("Link copied to clipboard");
    }
  };

  const formatPrice = (num) => {

    if (!num) return "-";
    num = Number(num);

    if (num >= 10000000) return (num / 10000000).toFixed(2) + " Cr";
    if (num >= 100000) return (num / 100000).toFixed(2) + " Lakhs";
    if (num >= 1000) return (num / 1000).toFixed(2) + " K";

    return num.toString();


  };
  const getRentalDetails = (id) => {
    setLoading(true);
    const cacheKey = `rental_details_${id}`;
    requestApi(cacheKey, () => get_rental_details(id))
      .then((res) => {
        setData(res?.data || {});
        setDocument(res?.data?.documents || []);
      })
      .catch(() => { })
      .finally(() => setLoading(false));
  };

  const fetchSettings = async () => {
    try {
      const res = await get_settings();
      if (res && res.data) {
        setSettings(res.data);
      }
    } catch (err) {
      console.error("Error fetching settings:", err);
    }
  };

  const fetchTerms = async () => {
    setLoadingBooking(true);
    setLoadingDownload(true);
    setLoadingDocument(true);
    try {
      const bookingRes = await get_page("gio_rental_yield__syndicate_plot_booking_terms_and_condition");
      if (bookingRes?.success && bookingRes?.data?.content) {
        setBookingTerms(bookingRes.data.content);
      }
      // const downloadRes = await get_page("gio_rental_yield_syndicate_plot_document_download_terms_and_condition");
      // if (downloadRes?.success && downloadRes?.data?.content) {
      //   setDownloadTerms(downloadRes.data.content);
      // }
      const docRes = await get_page("gio_rental_yield_document_terms_and_condition");
      if (docRes?.success && docRes?.data?.content) {
        setDocumentTerms(docRes.data.content);
      }
    } catch (err) {

    } finally {
      setLoadingBooking(false);
      setLoadingDownload(false);
      setLoadingDocument(false);
    }
  };


  useEffect(() => {
    getRentalDetails(id);
    fetchTerms();
    fetchSettings();
  }, [id]);


  const lat = data?.lat;
  const lng = data?.lng;
  const isValidLocation =
    lat !== null &&
    lng !== null &&
    lat !== "" &&
    lng !== "" &&
    !isNaN(lat) &&
    !isNaN(lng);

  // slider
  const images = Array.isArray(data?.files) ? data.files : [];
  const whatsappNumber = settings?.whatsapp;
  const showArrows = images.length > 1;
  // slider image preview 
  const showPreviewArrows = images.length > 1;
  const [previewOpen, setPreviewOpen] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);
  const previewSliderRef = useRef();


  const handleImagePreview = (index) => {
    setActiveIndex(index);
    setPreviewOpen(true);

    setTimeout(() => {
      previewSliderRef.current?.slickGoTo(index);
    }, 100);
  };

  const handlePayment = useCallback(
    async (totalPayableAmount, property_id) => {
      if (!acceptTerms) {
        toast.error("Accept the terms and conditions");
        return
      }

      setLoading(true);

      const loadRazorpay = () => {
        return new Promise((res) => {
          if (window.Razorpay) return res(window.Razorpay);
          const script = document.createElement("script");
          script.src = "https://checkout.razorpay.com/v1/checkout.js";
          script.onload = () => res(window.Razorpay);
          script.onerror = () => res(null);
          document.body.appendChild(script);
        });
      };

      const Razorpay = await loadRazorpay();
      if (!Razorpay) {
        toast.error("Razorpay SDK not loaded");
        setLoading(false);
        return;
      }

      const amountpay = totalPayableAmount || data?.amount_pay;
      const options = {
        key: settings?.payment_api_key || process.env.REACT_APP_RAZOR_PAY,
        amount: Math.round(amountpay * 100), // in paise
        currency: "INR",
        name: "Cashback Farms",
        description: "Plot",
        image: "/assets/icons/__Fav Icon.png",
        handler: async function (response) {
          const transactionId = response.razorpay_payment_id;

          const payLoad = {
            status: "success",
            payment_id: transactionId,
            transaction_details: "test",
            amount: amountpay,
            property_id: data?.id,
          };

          try {
            await rental_document_pay(payLoad);
            toast.success("Payment successful!");
            navigate("/dashboard/rental_enquiry")
          } catch (err) {
            toast.error("Something went wrong!");
            setLoading(false);
          }
        },
        theme: { color: "#C7DD94" },
      };

      const rzpay = new Razorpay(options);
      rzpay.open();

      rzpay.on("payment.failed", (response) => {
        toast.error(response.error.description || "Payment failed");
        setLoading(false);
      });
    },
    [data, acceptTerms, settings]
  );

  const handleRentalQuery = async () => {
    if (enquired) {
      toast.info("You have already sent an enquiry!");
      return;
    }
    const formData = {
      property_id: id
    };

    setEnquiredLoading(true);

    try {
      const res = await rental_enquiry(formData);

      if (res?.status === true) {
        toast.success("Enquiry submitted successfully!");
        setEnquired(true);
      } else if (res?.status === false && res?.code === 409) {

        toast.info(res?.data?.message || "You have already enquired");
        setEnquired(true);
      } else {
        toast.error(res?.data?.message || "Something went wrong");
      }
    } catch (error) {

      toast.error(
        error?.response?.data?.message || error?.message || "Failed to submit enquiry"
      );
    }

    setEnquiredLoading(false);
  };

  const handleReserve = async () => {
    setShowPaymentSummary(true);
    setTimeout(() => {
      const summarySection = document.getElementById("rental-payment-summary-section");
      if (summarySection) {
        summarySection.scrollIntoView({ behavior: 'smooth', block: 'center' });
      } else {
        const docSection = document.getElementById("land-verification-section");
        if (docSection) {
          docSection.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }
    }, 100);
  };

  const isVideo = (url) => {
    if (typeof url !== 'string') return false;
    return url.match(/\.(mp4|webm|mkv|mov|avi)$/i);
  };

  const togglePlay = (e, img) => {
    e.stopPropagation();
    const v = videoRefs.current[img];
    if (v) {
      if (!v.paused) {
        v.pause();
        setIsPlayingMap(prev => ({ ...prev, [img]: false }));
      } else {
        v.play();
        setIsPlayingMap(prev => ({ ...prev, [img]: true }));
      }
    }
  };

  const togglePreviewPlay = (e, img) => {
    e.stopPropagation();
    const v = previewVideoRefs.current[img];
    if (v) {
      if (!v.paused) {
        v.pause();
      } else {
        v.play();
      }
      setPreviewOpen(prev => prev); // Force re-render
    }
  };

  const handleProceedToKYC = async () => {
    setKycLoading(true);
    try {
      const res = await get_kyc_list();
      if (res.status) {
        setKycList(res.data || []);
        setShowKycSection(true);
        // Scroll to KYC section
        setTimeout(() => {
          const kycSection = document.getElementById("kyc-selection-section");
          if (kycSection) {
            kycSection.scrollIntoView({ behavior: "smooth", block: "center" });
          }
        }, 100);
      } else {
        toast.error(res.message || "Failed to fetch KYC list");
      }
    } catch (err) {
      toast.error("Error fetching KYC list");
    } finally {
      setKycLoading(false);
    }
  };

  const handleKycVerification = async () => {
    if (selectedKycIds.length === 0) {
      toast.error("Please select at least one beneficiary");
      return;
    }

    try {
      const payload = {
        "property_id": id,
        "transaction_id": data?.transaction_id,
        "benficiary_id[]": selectedKycIds,
        type: "rental",
      };

      const res = await kyc_verification(payload);
      if (res.status) {
        toast.success(res.message || "KYC Verification submitted successfully");
        setShowKycSection(false);
        await getRentalDetails(id);
        navigate("/dashboard/rental_enquiry");
        // window.location.reload();


      } else {
        toast.error(res.message || "KYC Verification failed");
      }
    } catch (err) {
      toast.error(err.response?.data?.message || err.message || "Error in KYC Verification");
    }
  };

  const rentalServiceChargePercent = parseFloat(parseFloat(settings?.rental_service_charge || 0).toFixed(2));
  const rentalIgstPercent = parseFloat(parseFloat(settings?.rental_igst || 0).toFixed(2));

  const rentalBaseAmount = parseFloat(data?.amount_pay || 0);
  const rentalServiceChargeAmount = parseFloat((rentalBaseAmount * (rentalServiceChargePercent / 100)).toFixed(2));
  const rentalIgstAmount = parseFloat((rentalBaseAmount * (rentalIgstPercent / 100)).toFixed(2));
  const rentalTotalAmount = parseFloat((rentalBaseAmount + rentalServiceChargeAmount + rentalIgstAmount).toFixed(2));

  return (
    <Container sx={{ py: 5 }}>
      <Box sx={{ mb: 3 }}>
        <BreadcrumbsNav />
      </Box>
      <Box
        sx={{
          backgroundImage: `url(/assets/images/plootbg.png)`,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
          my: 5,
          p: { xs: 2, sm: 3, md: 2 },
          borderRadius: "16px",
          boxShadow: "0 4px 12px rgba(0,0,0,0.12)",
        }}>
        {/* FLEX WRAPPER */}
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", lg: "row" },
            gap: { xs: 3, lg: 4 },
          }}
        >
          <Box
            sx={{
              bgcolor: "#fff",
              borderRadius: 4,
              p: { xs: 2, md: 2 },
              width: { xs: "100%", lg: "40%" },
              boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
            }}
          >
            <Box
              sx={{
                position: "relative",
                overflow: "hidden",

                /* DOT STYLES */
                "& .slick-dots": {
                  position: "absolute",
                  bottom: 10,
                  left: "50%",
                  transform: "translateX(-50%)",
                  margin: 0,
                  padding: "2px 6px",
                  borderRadius: "12px",
                  width: "auto",
                  display: "flex !important",
                  gap: "6px",
                  zIndex: 5,
                },

                "& .slick-dots li": {
                  width: 8,
                  height: 8,
                  borderRadius: "50%",
                  backgroundColor: "rgba(255,255,255,0.6)",
                },

                "& .slick-dots li.slick-active": {
                  backgroundColor: "#fff",
                },

                "& .slick-dots li button:before": {
                  content: '""',
                },
              }}
            >

              {/* SHARE ICON */}
              <IconButton
                onClick={handleShare}
                sx={{
                  position: "absolute",
                  top: 10,
                  right: 10,
                  zIndex: 3,
                  background: "white",
                  "&:hover": { background: "#f5f5f5" },
                }}
              >
                <ShareIcon fontSize="small" />
              </IconButton>

              {/* WhatsApp Icon (next to share) */}
              <IconButton
                onClick={(e) => {
                  e.stopPropagation();
                  const shareUrl = window.location.href;
                  const shareText = `Check out this property: ${data?.name || "Property"}\n${shareUrl}`;
                  window.open(`https://api.whatsapp.com/send?text=${encodeURIComponent(shareText)}`, "_blank");
                }}
                sx={{
                  position: "absolute",
                  top: 10,
                  right: 50,
                  zIndex: 3,
                  background: "white",
                  "&:hover": { background: "#f5f5f5" },
                }}
              >
                <WhatsAppIcon sx={{ color: "#25D366" }} fontSize="small" />
              </IconButton>

              {/* YouTube Icon (straight bottom to share icon) */}
              {data?.youtube_link && (
                <IconButton
                  onClick={() => window.open(data.youtube_link, "_blank")}
                  sx={{
                    position: "absolute",
                    bottom: 10,
                    right: 10,
                    zIndex: 3,
                    background: "white",
                    "&:hover": { background: "#f5f5f5" },
                  }}
                >
                  <YouTubeIcon sx={{ color: "#FF0000" }} fontSize="small" />
                </IconButton>
              )}

              {/* LEFT ARROW */}
              {showArrows && (
                <IconButton
                  onClick={() => sliderRef.current?.slickPrev()}
                  sx={{
                    position: "absolute",
                    left: 8,
                    top: "50%",
                    transform: "translateY(-50%)",
                    zIndex: 2,
                    color: "#fff",
                    bgcolor: "transparent",
                  }}
                >
                  <ArrowBackIosNewIcon sx={{ fontSize: 26 }} />
                </IconButton>
              )}


              {loading ? (
                <Skeleton
                  variant="rectangular"
                  height={280}
                  sx={{ borderRadius: 3 }}
                  animation="wave"
                />
              ) : (
                <Slider ref={sliderRef} {...sliderSettings}>
                  {(images.length > 0 ? images : ["/assets/images/no-image.png"]).map(
                    (img, i) => (
                      <Box key={i} px={1}>
                        <Box sx={{ height: 280, borderRadius: 3 }}>

                          {isVideo(img) ? (
                            <Box
                              onMouseEnter={() => setHoveredVideo(img)}
                              onMouseLeave={() => setHoveredVideo(null)}
                              sx={{ position: "relative", width: "100%", height: 280 }}
                            >
                              <video
                                ref={(el) => (videoRefs.current[img] = el)}
                                src={img}
                                muted
                                loop
                                playsInline
                                disablePictureInPicture
                                disableRemotePlayback
                                controlsList="nopictureinpicture"
                                onContextMenu={(e) => e.preventDefault()}
                                onClick={(e) => togglePlay(e, img)}
                                style={{
                                  width: "100%",
                                  height: 280,
                                  borderRadius: 12, // Match parent borderRadius: 3 (which is 24px usually but looks like 12px or 8px)
                                  objectFit: "cover",
                                  cursor: "pointer",
                                }}
                              />
                              {(hoveredVideo === img || !isPlayingMap[img]) && (
                                <IconButton
                                  onClick={(e) => togglePlay(e, img)}
                                  sx={{
                                    position: "absolute",
                                    top: "50%",
                                    left: "50%",
                                    transform: "translate(-50%, -50%)",
                                    bgcolor: "rgba(0,0,0,0.5)",
                                    color: "white",
                                    borderRadius: "4px", // Rectangular
                                    "&:hover": { bgcolor: "rgba(0,0,0,0.7)" },
                                  }}
                                >
                                  {isPlayingMap[img] ? <PauseIcon /> : <PlayArrowIcon />}
                                </IconButton>
                              )}
                            </Box>
                          ) : (
                            <CardMedia
                              component="img"
                              image={img}
                              onClick={() => {
                                setActiveIndex(i);
                                setPreviewOpen(true);
                              }}
                              sx={{
                                height: 280,
                                borderRadius: 3,
                                objectFit: "cover",
                                cursor: "pointer",
                              }}
                            />
                          )}

                        </Box>
                      </Box>
                    )
                  )}
                </Slider>
              )}


              {/* RIGHT ARROW */}
              {showArrows && (
                <IconButton
                  onClick={() => sliderRef.current?.slickNext()}
                  sx={{
                    position: "absolute",
                    right: 8,
                    top: "50%",
                    transform: "translateY(-50%)",
                    zIndex: 2,
                    color: "#fff",
                    bgcolor: "transparent",
                  }}
                >
                  <ArrowForwardIosIcon sx={{ fontSize: 26 }} />
                </IconButton>
              )}
            </Box>
          </Box>


          {/*RIGHT BOX ===== */}
          <Box
            sx={{
              borderRadius: 4,
              p: { xs: 2, md: 3 },
              width: { xs: "100%", lg: "100%" },
              display: "flex",
              flexDirection: "column",
              minHeight: "100%",
            }}
          >



            <Box sx={{ flexGrow: 1, display: "flex", flexDirection: "column", gap: 2 }}>
              {/* ROW 1 */}
              <Box sx={{ display: "flex", flexDirection: { xs: "column", sm: "row" }, gap: 3 }}>
                <Box sx={{ flex: 1, minWidth: 0 }}>
                  <InfoItem
                    title="Project Name"
                    icon="/assets/images/crown.png"
                    value={data?.name || "-"}
                    loading={loading}
                  />
                </Box>
                <Box sx={{ flex: 1, minWidth: 0 }}>
                  <InfoItem
                    title="Location"
                    icon="/assets/images/loca.png"
                    value={data?.address || "-"}
                    loading={loading}
                  />
                </Box>
              </Box>

              <Divider />

              {/* ROW 2 */}
              <Box sx={{ display: "flex", flexDirection: { xs: "column", sm: "row" }, gap: 3 }}>
                <Box sx={{ flex: 1, minWidth: 0 }}>
                  <InfoItem
                    title="Plot Type"
                    icon="/assets/images/markplot.png"
                    value={data?.property_category?.category_name || "-"}
                    loading={loading}
                  />
                </Box>
                <Box sx={{ flex: 1, minWidth: 0 }}>
                  <InfoItem
                    title="Plot Area"
                    icon="/assets/images/area.png"
                    value={data?.plot_area ? `${data.plot_area} Sq ft` : "-"}
                    loading={loading}
                  />
                </Box>
              </Box>

              <Divider />

              {/* ROW 3 */}
              <Box sx={{ display: "flex", flexDirection: { xs: "column", sm: "row" }, gap: 3 }}>
                <Box sx={{ flex: 1, minWidth: 0 }}>
                  <InfoItem
                    title="Total Price"
                    icon="/assets/images/pricetag.png"
                    value={formatPrice(data?.total_price)}
                    loading={loading}
                  />
                </Box>
                <Box sx={{ flex: 1, minWidth: 0 }}>
                  <InfoItem
                    title="Per sqft"
                    icon="/assets/images/discount.png"
                    value={`₹${data?.price_per_sqft || "-"}`}
                    loading={loading}
                  />
                </Box>
              </Box>

              <Divider />

              {/* ROW 4 */}
              <Box sx={{ display: "flex", flexDirection: { xs: "column", sm: "row" }, gap: 3 }}>
                <Box sx={{ flex: 1, minWidth: 0 }}>
                  <InfoItem
                    title="ULPIN No."
                    icon="/assets/images/count.png"
                    value={data?.ulpn_no || "-"}
                    loading={loading}
                  />
                </Box>
                <Box sx={{ flex: 1, minWidth: 0 }} />
              </Box>
            </Box>




            <Box display="flex" justifyContent="center" mt={1}>
              <Button
                variant="contained"
                sx={{
                  background: "#FEB821",
                  borderRadius: 20,

                  px: { xs: 2.5, sm: 3.5 },
                  py: 0.8,

                  minWidth: "auto",
                  width: "fit-content",
                  textTransform: "capitalize",
                  fontSize: { xs: 14, sm: 14 },
                  fontWeight: 500,

                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                  color: "#000",
                  "&:hover": { background: "#FEB821" },
                }}
                disabled={enquired || data?.sold_status === 1 || data?.doucment_verficaiton == true || data?.is_anyone_booked}
                onClick={() => handleReserve()}
              >
                <CallIcon sx={{ fontSize: 18 }} />

                {enquiredloading ? (
                  <CircularProgress color="inherit" size={18} />
                ) : data?.sold_status === 1 ? (
                  "Sold Out"
                ) : data?.is_anyone_booked ? (
                  data?.booked ? "Enquired" : "Enquired by someone"
                ) : (enquired || data?.doucment_verficaiton == true) ? (
                  "Enquired"
                ) : (
                  "Send Enquiry"
                )}
              </Button>

              {/* CONFIRM POPUP */}
              <Dialog
                open={confirmOpen}
                onClose={() => setConfirmOpen(false)}
                maxWidth="xs"
                fullWidth
              >
                <DialogTitle>Confirm Enquiry</DialogTitle>

                <DialogContent>
                  <Typography>
                    Are you sure you want to send this enquiry?
                  </Typography>
                </DialogContent>

                <DialogActions>
                  <Button variant="outlined" onClick={() => setConfirmOpen(false)}>
                    No
                  </Button>

                  <Button
                    variant="contained"
                    sx={{ bgcolor: "#6BAF4B" }}
                    onClick={() => {
                      setConfirmOpen(false);
                      handleRentalQuery();
                    }}
                  >
                    Yes
                  </Button>
                </DialogActions>
              </Dialog>
            </Box>
          </Box>
        </Box>
      </Box>



      <Box
        sx={{
          mt: 6,
          display: "flex",
          flexDirection: { xs: "column", lg: "row" },
          gap: { xs: 4, lg: 6 },
          width: "100%",
        }}
      >
        {/* LEFT: LOCATION */}
        <Box sx={{ flex: 1, width: { xs: "100%", lg: "50%" } }}>
          <Typography fontWeight={600} mb={2} color="#608900">
            LOCATION:
          </Typography>

          {/* MAP CONTAINER */}
          <Box
            sx={{
              width: "100%",
              borderRadius: 3,
              overflow: "hidden",
              border: "1px solid #e0e0e0",
              bgcolor: "#f5f5f5",
              position: "relative",
              height: {
                xs: 200,
                sm: 200,
                md: 220,
                lg: 200,
              },
            }}
          >
            {loading ? (
              <Skeleton
                variant="rectangular"
                width="100%"
                height="100%"
                animation="wave"
                sx={{ position: "absolute", top: 0, left: 0, zIndex: 1 }}
              />
            ) : (
              <iframe
                title="Property Location Map"
                src={`https://www.google.com/maps?q=${lat},${lng}&z=15&output=embed`}
                width="100%"
                height="100%"
                style={{ border: 0 }}
              />
            )}
          </Box>
        </Box>

        {/* RIGHT: HOW IT WORKS */}
        <Box sx={{ flex: 1, width: { xs: "100%", lg: "50%" } }}>
          <Typography fontWeight={600} mb={2} color="#495057">
            How It Works
          </Typography>

          <Box
            sx={{
              display: "flex",
              alignItems: { xs: "center", sm: "flex-start" },
              justifyContent: "space-between",
              flexDirection: { xs: "column", sm: "row" },
              py: 2,
              position: "relative",
              height: "100%",
            }}
          >
            <Box
              sx={{
                position: "absolute",
                top: 55,
                left: 40,
                right: 40,
                display: { xs: "none", sm: "block" },
                borderBottom: "2px dashed #92AF5D",
                zIndex: 0,
              }}
            />

            {[
              {
                icon: "/assets/icons/support.png",
                label: `Pay ₹${rentalTotalAmount} (include gst) for Land Document Verification`,
              },
              {
                icon: "/assets/icons/preferred_plot.png",
                label: "Request details about this land",
              },
              {
                icon: "/assets/icons/proceed.png",
                label: "Reserve and proceed to purchase your desired plot.",
              },
              {
                icon: "/assets/icons/refer_friends.png",
                label: "Refer Friends & Earn Rewards!",
              },
            ].map((step, index) => (
              <Box
                key={index}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  position: "relative",
                  flex: "1 1 0",
                  zIndex: 1,
                  px: 1,
                  mb: { xs: 3, sm: 0 },
                }}
              >
                <Box
                  sx={{
                    width: 70,
                    height: 70,
                    borderRadius: "50%",
                    border: "3px solid #92AF5D",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: "#fff",
                  }}
                >
                  <img src={step.icon} alt={step.label} style={{ width: 35, height: 35 }} />
                </Box>

                <Typography
                  variant="h6"
                  sx={{
                    mt: 1.5,
                    textAlign: "center",
                    color: "text.secondary",
                    fontWeight: 400,
                    fontSize: 13,
                  }}
                >
                  {step.label}
                </Typography>
              </Box>
            ))}
          </Box>
        </Box>
      </Box>


      {data?.description?.trim() && (
        <Box sx={{ mt: 5 }}>
          <RentalDescription
            area={data?.area}
            per_sq={data?.unit_spilt}
            price={data?.price}
            totalPrice={data?.total_price}
            description={data?.description}
          />
        </Box>
      )}

      {(data?.blueprint || data?.plot_structure) && (
        <Box
          sx={{
            mt: 6,
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            gap: { xs: 2.5, md: 4 },
            width: "100%",
          }}
        >
          {data?.blueprint && (
            <Box sx={{ flex: 1, height: { xs: 260, sm: 300, md: 420 } }}>
              <ResdentialImageView
                image={data.blueprint}
                viewerId="blueprint-viewer"
                title="GreenHeap Plots Layout Sketch"
                variant="blueprint"
              />
            </Box>
          )}

          {data?.plot_structure && (
            <Box sx={{ flex: 1, height: { xs: 260, sm: 300, md: 420 } }}>
              <ResdentialImageView
                image={data.plot_structure}
                viewerId="threed-viewer"
                title="Aerial View"
                variant="blueprint"
              />
            </Box>
          )}
        </Box>
      )}

      <Box sx={{ mt: 5 }}>
        {/* <RentalDocument
  documents={document}
  amount={data?.amount_pay}
  handlePayment={handlePayment}
  paid={data?.doucment_verficaiton}

/> */}
        <Box
          sx={{
            display: { xs: "block", md: "flex" },
            gap: 3,
            alignItems: "flex-start",
            mb: 2
          }}
        >



          {
            // documents.length > -1 ?
            documents.length > 0 && data?.doucment_verficaiton == false && data?.doucment_verficaiton != null && <Box id="land-verification-section" sx={{ flex: 2 }}>
              <Box
                sx={{
                  position: "relative",
                  my: 2,
                  borderRadius: 3,
                  overflow: "hidden",
                  border: "1px solid #E0E0E0",
                  boxShadow: 1,
                  backgroundImage: "url('/assets/images/service_cat_bg.png')",
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  minHeight: 250,
                  width: "100%",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  p: 2,
                  color: "#000",
                }}
              >
                <Typography
                  sx={{
                    backgroundColor: "rgba(255,255,255,0.7)",
                    px: 2,
                    py: 1,
                    borderRadius: 1,
                    fontWeight: 600,
                    fontSize: 18,
                    textAlign: "center",
                    mb: 1,
                  }}
                >
                  Land Document Verification
                </Typography>

                <Box
                  component="ul"
                  sx={{
                    px: { xs: 3, md: 10 },
                    m: 0,
                    listStyleType: "disc",
                    fontSize: 20,
                    fontWeight: 400,
                    lineHeight: 1.5,
                    textAlign: "start",
                  }}
                >
                  <li>Before purchasing, ensure your land is legally verified.</li>
                  <li>
                    Verify the property documents for complete peace of mind before
                    you invest.
                  </li>
                  <li>Pay ₹{rentalTotalAmount} (include gst) for instant verification.</li>

                </Box>

                {documentTerms && (
                  <Box sx={{ width: '100%', mt: 2, px: { xs: 2, md: 5 } }}>
                    <Typography variant="caption" sx={{ fontWeight: 600, color: 'text.secondary', mb: 0.5, display: 'block' }}>
                      Document Terms & Conditions
                    </Typography>
                    <Box
                      sx={{
                        maxHeight: 120,
                        overflowY: "auto",
                        border: "1px solid #e0e0e0",
                        borderRadius: 1,
                        p: 1.5,
                        backgroundColor: "rgba(255, 255, 255, 0.7)",
                        fontSize: "0.75rem",
                        "& p": { mb: 1 },
                        "& ul, & ol": { pl: 2, mb: 1 }
                      }}
                      dangerouslySetInnerHTML={{ __html: documentTerms }}
                    />
                  </Box>
                )}


                {!showPaymentSummary ? (
                  <Box
                    sx={{ display: "flex", flexDirection: "column", justifyContent: "center" }}
                  >
                    <Box sx={{ display: "flex", alignItems: "center", justifyItems: "center", mt: 2 }}>
                      <Checkbox sx={{ color: "#92AF5D" }} checked={acceptTerms}
                        onChange={(e) => setAcceptTerms(e.target.checked)} />

                      <Typography variant="body2">
                        I agree to the{" "}
                        <Link
                          to="/pages/gio_rental_yield_document_terms_and_condition"
                          style={{
                            textDecoration: "none",
                            color: "black",
                            fontWeight: "bold",
                          }}
                          onClick={(e) => e.stopPropagation()} // important!
                        >
                          Terms and Conditions
                        </Link>

                      </Typography>

                    </Box>
                    <Button
                      variant="contained"
                      sx={{
                        borderRadius: 10,
                        px: 7,
                        my: 2,
                        backgroundColor: loading ? "#ccc" : "#FEB821",
                        color: "#000",
                        textTransform: "none",
                        cursor: loading ? "not-allowed" : "pointer",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: 1,
                        "&:hover": {
                          backgroundColor: loading ? "#ccc" : "#e4a61b",
                        },
                      }}
                      onClick={() =>
                        requireLogin(() =>
                          handlePayment(rentalTotalAmount, data?.id)
                        )
                      }
                      disabled={paymentLoading || data?.sold_status === 1}
                    >
                      {paymentLoading ? (
                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                          <CircularProgress size={20} sx={{ color: "#000" }} />
                          Processing...
                        </Box>
                      ) : data?.sold_status === 1 ? (
                        "Sold Out"
                      ) : (
                        "Pay Now"
                      )}
                    </Button>
                  </Box>
                ) : (
                  <Box
                    id="rental-payment-summary-section"
                    sx={{
                      mt: 3,
                      p: 2.5,
                      borderRadius: "16px",
                      bgcolor: "#edf4fc",
                      border: "1px solid #d2e4f7",
                      boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.05)",
                      width: "100%",
                      maxWidth: 500,
                    }}
                  >
                    <Typography variant="h6" fontWeight="bold" sx={{ color: "#1e3d59", mb: 1, textAlign: "left" }}>
                      Payment Summary
                    </Typography>
                    
                    <Typography variant="body2" fontWeight="500" sx={{ color: "grey.700", mb: 0.5, textAlign: "left" }}>
                      Calculation:
                    </Typography>

                    <Typography variant="body2" sx={{ color: "#2e7d32", fontWeight: "bold", mb: 1, textAlign: "left" }}>
                      1 plots × ₹{rentalBaseAmount.toFixed(2)} = ₹{rentalBaseAmount.toFixed(2)}
                    </Typography>

                    <Divider sx={{ my: 1, borderColor: "#ccc" }} />

                    <Box sx={{ display: "flex", justifyContent: "space-between", my: 0.5 }}>
                      <Typography variant="body2" sx={{ color: "grey.700" }}>Base Amount:</Typography>
                      <Typography variant="body2" fontWeight="600">₹{rentalBaseAmount.toFixed(2)}</Typography>
                    </Box>

                    <Box sx={{ display: "flex", justifyContent: "space-between", my: 0.5 }}>
                      <Typography variant="body2" sx={{ color: "grey.700" }}>
                        Rental Service Charge ({rentalServiceChargePercent}%):
                      </Typography>
                      <Typography variant="body2" fontWeight="600">
                        + ₹{rentalServiceChargeAmount.toFixed(2)}
                      </Typography>
                    </Box>

                    <Box sx={{ display: "flex", justifyContent: "space-between", my: 0.5 }}>
                      <Typography variant="body2" sx={{ color: "grey.700" }}>
                        Rental IGST ({rentalIgstPercent}%):
                      </Typography>
                      <Typography variant="body2" fontWeight="600">
                        + ₹{rentalIgstAmount.toFixed(2)}
                      </Typography>
                    </Box>

                    <Divider sx={{ my: 1, borderColor: "#ccc" }} />

                    <Box sx={{ display: "flex", justifyContent: "space-between", my: 1 }}>
                      <Typography variant="body1" fontWeight="bold" sx={{ color: "#1e3d59" }}>Total Amount:</Typography>
                      <Typography variant="body1" fontWeight="bold" sx={{ color: "#2e7d32" }}>
                        ₹{rentalTotalAmount.toFixed(2)}
                      </Typography>
                    </Box>

                    <Box sx={{ display: "flex", alignItems: "flex-start", mt: 2 }}>
                      <Checkbox
                        size="small"
                        sx={{ color: "#92AF5D", p: 0, mr: 1, mt: 0.2 }}
                        checked={acceptTerms}
                        onChange={(e) => setAcceptTerms(e.target.checked)}
                      />
                      <Typography variant="body2" sx={{ fontSize: 13, color: "grey.800", textAlign: "left" }}>
                        I have read and agree to the{" "}
                        <Link
                          to="/pages/gio_rental_yield_document_terms_and_condition"
                          style={{ textDecoration: "none", color: "#608900", fontWeight: "bold" }}
                          onClick={(e) => e.stopPropagation()}
                        >
                          Terms & Conditions
                        </Link>
                      </Typography>
                    </Box>

                    {!acceptTerms && (
                      <Typography variant="caption" sx={{ color: "red", display: "block", mt: 0.5, textAlign: "left" }}>
                        * Please accept terms to continue
                      </Typography>
                    )}

                    <Button
                      variant="contained"
                      fullWidth
                      sx={{
                        mt: 2,
                        borderRadius: "50px",
                        backgroundColor: acceptTerms ? "#FEB821" : "#d3d3d3",
                        color: "black",
                        fontWeight: "bold",
                        textTransform: "none",
                        py: 1,
                        "&:hover": { backgroundColor: acceptTerms ? "#e4a61b" : "#d3d3d3" }
                      }}
                      onClick={() => {
                        if (!acceptTerms) {
                          toast.error("Please accept the terms and conditions");
                          return;
                        }
                        requireLogin(async () => {
                          await handlePayment(rentalTotalAmount, data?.id);
                        });
                      }}
                      disabled={paymentLoading || data?.sold_status === 1}
                    >
                      {paymentLoading ? (
                        <Box sx={{ display: "flex", alignItems: "center", gap: 1, justifyContent: "center" }}>
                          <CircularProgress size={20} sx={{ color: "#000" }} />
                          Processing...
                        </Box>
                      ) : (
                        `Pay ₹${rentalTotalAmount.toFixed(2)}`
                      )}
                    </Button>

                    <Typography variant="caption" display="block" align="center" sx={{ color: "grey.600", mt: 1 }}>
                      (1 plots × ₹{rentalBaseAmount.toFixed(2)})
                    </Typography>
                  </Box>
                )}
              </Box>

            </Box>
            // <Box
            //   sx={{
            //     position: "relative",
            //     my: 2,
            //     borderRadius: 3,
            //     overflow: "hidden",
            //     border: "1px solid #E0E0E0",
            //     boxShadow: 1,
            //     backgroundImage: "url('/assets/images/service_cat_bg.png')",
            //     backgroundSize: "cover",
            //     backgroundPosition: "center",

            //     width: "100%",
            //     display: "flex",
            //     flexDirection: "column",
            //     alignItems: "center",
            //     justifyContent: "center",
            //     p: 2,
            //     color: "#000",
            //   }}
            // >
            //   <Typography
            //     sx={{
            //       backgroundColor: "rgba(255,255,255,0.7)",
            //       px: 2,
            //       py: 1,
            //       borderRadius: 1,

            //       fontSize: 18,
            //       textAlign: "center",
            //       mb: 1,
            //     }}
            //   >
            //     No Documents Found
            //   </Typography>




            // </Box>
          }
        </Box>



        {data?.doucment_verficaiton == true && data?.doucment_verficaiton != null && downloadTerms && (
          <Box sx={{ mb: 2 }}>
            <Typography variant="caption" sx={{ fontWeight: 600, color: 'text.secondary', mb: 0.5, display: 'block' }}>
              Document Download Terms & Conditions
            </Typography>
            <Box
              sx={{
                maxHeight: 120,
                overflowY: "auto",
                border: "1px solid #e0e0e0",
                borderRadius: 2,
                p: 2,
                backgroundColor: "#fff",
                fontSize: "0.8rem",
                "& p": { mb: 1 },
                "& ul, & ol": { pl: 2, mb: 1 }
              }}
              dangerouslySetInnerHTML={{ __html: downloadTerms }}
            />
          </Box>
        )}

        <PlotDocumentSection documents={documents} loading={loading} documentVerified={data?.doucment_verficaiton == true && data?.doucment_verficaiton != null} onProceedToKYC={handleProceedToKYC} kycVerified={data?.kyc_verified} navigatePath="/dashboard/rental_enquiry" />

        {showKycSection && (
          <Box id="kyc-selection-section" sx={{ mt: 4, p: 3, borderRadius: 3, boxShadow: 2, backgroundColor: "#fff" }}>
            <Typography variant="h6" fontWeight={700} sx={{ color: "#608900", mb: 2 }}>
              Select KYC Beneficiary
            </Typography>
            <Grid container spacing={2}>
              {kycList.length > 0 ? (
                <>
                  {kycList.map((kyc) => (
                    <Grid item xs={12} sm={6} md={4} key={kyc.id}>
                      <Box
                        onClick={() => {
                          setSelectedKycIds((prev) =>
                            prev.includes(kyc.id)
                              ? prev.filter((id) => id !== kyc.id)
                              : [...prev, kyc.id]
                          );
                        }}
                        sx={{
                          p: 2,
                          border: "2px solid",
                          borderColor: selectedKycIds.includes(kyc.id) ? "#608900" : "#eee",
                          borderRadius: 2,
                          cursor: "pointer",
                          backgroundColor: selectedKycIds.includes(kyc.id) ? "#f0f7f0" : "transparent",
                          transition: "0.2s",
                          "&:hover": { borderColor: "#608900" },
                          display: 'flex',
                          flexDirection: 'column',
                          height: '100%',
                          justifyContent: 'center'
                        }}
                      >
                        <Typography fontWeight={600}>{kyc.name}</Typography>
                        <Typography variant="body2" color="text.secondary">
                          PAN: {kyc.pan_no}
                        </Typography>
                      </Box>
                    </Grid>
                  ))}
                  <Grid item xs={12} sm={6} md={4}>
                    <Box
                      onClick={() => navigate("/dashboard/kyc-details")}
                      sx={{
                        p: 2,
                        border: "2px dashed #608900",
                        borderRadius: 2,
                        cursor: "pointer",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        height: "100%",
                        backgroundColor: "#f9fff9",
                        transition: "0.2s",
                        "&:hover": { backgroundColor: "#f0f7f0" },
                      }}
                    >
                      <AddCircleOutlineIcon sx={{ color: "#608900", fontSize: 40, mb: 1 }} />
                      <Typography fontWeight={600} color="#608900">Add New Beneficiary</Typography>
                    </Box>
                  </Grid>
                </>
              ) : (
                <Grid item xs={12}>
                  <Box
                    sx={{
                      p: 4,
                      border: "2px dashed #ccc",
                      borderRadius: 2,
                      textAlign: "center",
                      backgroundColor: "#fafafa",
                      width: '100%'
                    }}
                  >
                    <Typography sx={{ mb: 2 }}>No KYC beneficiaries found.</Typography>
                    <Button
                      variant="contained"
                      onClick={() => navigate("/dashboard/kyc-details")}
                      sx={{
                        backgroundColor: "#608900",
                        color: "#fff",
                        textTransform: "none",
                        fontWeight: "bold",
                        px: 4,
                        py: 1.5,
                        borderRadius: "50px",
                        "&:hover": { backgroundColor: "#4a6a00" },
                      }}
                    >
                      Add KYC Details
                    </Button>
                  </Box>
                </Grid>
              )}
            </Grid>

            {selectedKycIds.length > 0 && (
              <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
                <Button
                  variant="contained"
                  onClick={handleKycVerification}
                  sx={{
                    backgroundColor: "#608900",
                    color: "#fff",
                    textTransform: "none",
                    fontWeight: "bold",
                    px: 4,
                    py: 1.5,
                    borderRadius: "50px",
                    "&:hover": { backgroundColor: "#4a6a00" },
                  }}
                >
                  KYC Verification
                </Button>
              </Box>
            )}
          </Box>
        )}


      </Box>





      <Box sx={{ my: 4 }}>
        <RentalLocation
          address={data?.address}
          uldNumber={data?.id}
          amenity={data?.amenity}
          nearbyLocations={data?.nearbyLocations}

        />
      </Box>
      <Box>
        <Dialog
          open={previewOpen}
          onClose={() => setPreviewOpen(false)}
          maxWidth="lg"
          fullWidth
          PaperProps={{
            sx: {
              borderRadius: 2,
              overflow: "hidden",
              bgcolor: "rgba(0,0,0,0.5)",
            },
          }}
        >
          {/* CLOSE BUTTON (TOP RIGHT) */}
          <IconButton
            onClick={() => setPreviewOpen(false)}
            sx={{
              position: "absolute",
              top: { xs: 10, sm: 16 },
              right: { xs: 10, sm: 20 },
              zIndex: 10,
              color: "#fff",
            }}
          >
            <CloseIcon />
          </IconButton>

          <DialogContent sx={{ p: 0 }}>
            <Box
              sx={{
                position: "relative",
                height: { xs: 320, sm: 500, md: 600 },
                bgcolor: "transparent",
                overflow: "hidden"
              }}
            >
              {/* LEFT ARROW */}
              {showPreviewArrows && (
                <IconButton
                  onClick={() => previewSliderRef.current?.slickPrev()}
                  sx={{
                    position: "absolute",
                    left: 12,
                    top: "50%",
                    transform: "translateY(-50%)",
                    zIndex: 3,
                    color: "#fff",
                    bgcolor: "rgba(0,0,0,0.5)",

                    "&:hover": { bgcolor: "rgba(0,0,0,0.7)" },
                  }}
                >
                  <ArrowBackIosNewIcon />
                </IconButton>
              )}
              {/* SLIDER */}
              <Slider
                ref={previewSliderRef}
                initialSlide={activeIndex}
                dots
                infinite
                speed={400}
                slidesToShow={1}
                slidesToScroll={1}
                arrows={false}
              >
                {images.map((img, i) => (
                  <Box key={i}>
                    <Box
                      sx={{
                        height: { xs: 320, sm: 500, md: 600 },
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        bgcolor: "rgba(0,0,0,0.5)",
                        p: 1,
                      }}
                    >
                      {isVideo(img) ? (
                        <Box
                          onMouseEnter={() => setHoveredVideo(img)}
                          onMouseLeave={() => setHoveredVideo(null)}
                          sx={{ position: "relative", width: "100%", height: "100%" }}
                        >
                          <video
                            ref={(el) => (previewVideoRefs.current[img] = el)}
                            src={img}
                            loop
                            muted
                            playsInline
                            disablePictureInPicture
                            disableRemotePlayback
                            controlsList="nopictureinpicture"
                            onContextMenu={(e) => e.preventDefault()}
                            onClick={(e) => togglePreviewPlay(e, img)}
                            style={{
                              width: "100%",
                              height: "100%",
                              objectFit: "contain",
                            }}
                          />
                          {(hoveredVideo === img || !isPlayingMap[img]) && (
                            <IconButton
                              onClick={(e) => togglePreviewPlay(e, img)}
                              sx={{
                                position: "absolute",
                                top: "50%",
                                left: "50%",
                                transform: "translate(-50%, -50%)",
                                bgcolor: "rgba(0,0,0,0.5)",
                                color: "white",
                                borderRadius: "4px", // Rectangular
                                "&:hover": { bgcolor: "rgba(0,0,0,0.7)" },
                              }}
                            >
                              {isPlayingMap[img] ? <PauseIcon /> : <PlayArrowIcon />}
                            </IconButton>
                          )}
                        </Box>
                      ) : (
                        <img
                          src={img}
                          alt=""
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "contain",
                          }}
                        />
                      )}
                    </Box>
                  </Box>
                ))}
              </Slider>

              {/* RIGHT ARROW */}
              {showPreviewArrows && (
                <IconButton
                  onClick={() => previewSliderRef.current?.slickNext()}
                  sx={{
                    position: "absolute",
                    right: 12,
                    top: "50%",
                    transform: "translateY(-50%)",
                    zIndex: 3,
                    color: "#fff",
                    bgcolor: "rgba(0,0,0,0.5)",
                    "&:hover": { bgcolor: "rgba(0,0,0,0.7)" },
                  }}
                >
                  <ArrowForwardIosIcon />
                </IconButton>
              )}
            </Box>
          </DialogContent>
        </Dialog>
      </Box>
    </Container>
  );
}



function InfoItem({ icon, title, value, loading }) {
  return (
    <Box sx={{ display: "flex", gap: 1, alignItems: "flex-start" }}>

      {/* ICON */}
      <Box
        sx={{
          height: 42,
          display: "flex",
          alignItems: "flex-start",
          justifyContent: "flex-start",
          width: 40,
        }}
      >
        {loading ? (
          <Skeleton variant="circular" width={30} height={30} animation="wave" />
        ) : (
          <img src={icon} height={30} style={{ objectFit: "contain", maxWidth: "100%" }} alt="" />
        )}
      </Box>

      {/* TEXT */}
      <Box sx={{ flex: 1, minWidth: 0, wordBreak: "break-word" }}>
        {loading ? (
          <>
            <Skeleton width={80} height={18} animation="wave" />
            <Skeleton width={120} height={18} animation="wave" />
          </>
        ) : (
          <>
            <Typography
              sx={{
                fontSize: 13,
                fontWeight: 600,
                color: theme.palette.primary.main,
                lineHeight: 1.2,
                mb: 0.5,
              }}
            >
              {title}
            </Typography>

            <Typography sx={{ fontSize: 14, fontWeight: 500, whiteSpace: "normal" }}>
              {value || "-"}
            </Typography>
          </>
        )}
      </Box>

    </Box>
  );
}


